<div>
  <p>Tabs can be enabled or disabled by changing <code>disabled</code> input property</p>
  <p>
    <button type="button" class="btn btn-primary btn-sm" (click)="disableEnable()">
      Enable / Disable third tab
    </button>
  </p>
  <hr/>
  <tabset #staticTabs>
    <tab heading="Static title">Static content</tab>
    <tab heading="Static Title 1">Static content 1</tab>
    <tab heading="Static Title 2">Static content 2</tab>
    <tab heading="Static Title 3">Static content 3</tab>
  </tabset>
</div>
